export default {
    isCustomerLogged: function (state) {
        return state.loggedCustomer != null;
    }
};
